import { Molecule } from 'AppReact';
import styled from 'styled-components';
import { Icon, SearchInput } from './atoms';
import { MagnifyingGlassSvg } from 'components/icons';

const template = styled.div`
  position: relative;
  margin-bottom: 10px;
`;

export default Molecule({
  template,
  atoms: [
    {
      component: SearchInput,
      name: 'SearchInput',
    },
    {
      component: Icon,
      name: 'SearchIcon',
      displayValue: ({ }) => MagnifyingGlassSvg({ width: '16', height: '16', color: window?.settings?.secondary_color ?? '#04333b' }),
    }
  ]
})